import { ActionReducer, MetaReducer } from '@ngrx/store';
import { Storage } from '../shared/storage';
import { AUTH_FEATURE_KEY } from '../auth/store/auth.reducer';
import { DATA_FEATURE_KEY } from './data.reducer';
import { LoggerService } from '../shared/services/logger.service';
import { EXERCISE_FEATURE_KEY } from '../exercise/store/exercise.reducer';
import { CLIENT_FEATURE_KEY } from '../client/store/client.reducer';

const actions = [
  '@ngrx/store/init',
  '@ngrx/effects/init',
  '@app/storage/hydrate',
  '@app/storage/hydrate-success',
  '@app/storage/hydrate-failure',
];

export function storageMetaReducer(logger: LoggerService): MetaReducer {
  return (reducer: ActionReducer<any>): ActionReducer<any> => {
    return (state, action) => {
      const nextState = reducer(state, action);
      if (actions.includes(action.type)) {
        return nextState;
      }
      logger.debug('StorageMetaReducer', 'Action type', action.type, 'State', state, 'Next state', nextState);
      // handle the logout action removing from the local storage the data and
      // returning the next state, otherwise handle state per state all the persisted data.
      if (action.type === '@app/auth/logout') {
        Storage.remove(AUTH_FEATURE_KEY);
        Storage.remove(DATA_FEATURE_KEY);
        Storage.remove(EXERCISE_FEATURE_KEY);
        Storage.remove(CLIENT_FEATURE_KEY);
        return nextState;
      }
      if (action.type.includes('@app/auth') && nextState.auth) {
        Storage.setJSON(AUTH_FEATURE_KEY, nextState.auth);
      }
      if (action.type.includes('@app/data') && nextState.data) {
        Storage.setJSON(DATA_FEATURE_KEY, nextState.data);
      }
      if (action.type.includes('@app/exercise') && nextState.exercise) {
        Storage.setJSON(EXERCISE_FEATURE_KEY, nextState.exercise);
      }
      if (action.type.includes('@app/client') && nextState.client) {
        Storage.setJSON(CLIENT_FEATURE_KEY, nextState.client);
      }
      return nextState;
    };
  };
}
